export enum AspectRatio {
    RATIO_SQUARE = "ratio-square",
    RATIO_4_3 = "ratio-4-3",
    RATIO_5_3 = "ratio-5-3",
    RATIO_16_9 = "ratio-16-9",
    RATIO_3_4 = "ratio-3-4",
}
